export default __webpack_public_path__ + "static/media/matching-game.09568e37.jpg";